import { useShowResponseStatus } from '@/shared';
import { useCreatePaymentSystemMutation } from '../store/payment-system-api';
import { handlePaymentSystemCreateError } from '../utils/helpers/payment-systems-errors';

import type { TPaymentSystemCreateParams } from '../store/types';

export const useCreatePaymentSystems = () => {
  const [createPaymentSystem, { isLoading, isSuccess, error }] = useCreatePaymentSystemMutation();
  const createError = handlePaymentSystemCreateError(error);

  useShowResponseStatus({
    isSuccess,
    successMessage: 'Платёжная система успешно добавлена',
    error: createError,
  });

  const handleCreatePaymentSystem = async (params: TPaymentSystemCreateParams) => {
    await createPaymentSystem(params);
  };

  return {
    handleCreatePaymentSystem,
    createPaymentSystem,
    isLoading,
  };
};
